import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import RequisitionDetail from '@features/client/requisitions/RequisitionDetail.tsx';
import { PermissionTypesEnum } from '@mock/Permissions.ts';

export const Route = createFileRoute('/c/$orgId/$portalId/requisitions/$requisitionId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { requisitionId } = Route.useParams();

  return (
    <UserLayout oneOfPermission={[PermissionTypesEnum.CLIENT_ORDER_CREATE_REQUISITION, PermissionTypesEnum.CLIENT_REQUISITION_PROCESS]}>
      <div className="max-w-[1200px] mx-auto">
        <RequisitionDetail requisitionId={Number(requisitionId)} />
      </div>
    </UserLayout>
  );
}
